<script>
import { Line } from 'vue-chartjs'

import formatDate from '@/module/util/format-date'

export default {
    name: 'nutrition-graph-2d',
    extends: Line,
    
    props: {
        data: {
            type: Array
        }
    },

    mounted() {
        
        this.renderChart({
            labels: this.getTimeLabelArray(),
            datasets: [
                {
                    label: 'Calories',
                    fill: false,
                    borderColor: '#2d3e4f',
                    pointBackgroundColor: '#2d3e4f',
                    borderWidth: '2',
                    data: this.energyData,
                    yAxisID: 'y-axis-1'
                },
                {
                    label: 'Carbs',
                    fill: false,
                    borderColor: '#ea895a',
                    pointBackgroundColor: '#ea895a',
                    borderWidth: '2',
                    data: this.carbohydratesData,
                    yAxisID: 'y-axis-2'
                },
                {
                    label: 'Fat',
                    fill: false,
                    borderColor: '#5fbfe6',
                    pointBackgroundColor: '#5fbfe6',
                    borderWidth: '2',
                    data: this.fatData,
                    yAxisID: 'y-axis-2'
                },
                {
                    label: 'Protein',
                    fill: false,
                    borderColor: '#c27fff',
                    pointBackgroundColor: '#c27fff',
                    borderWidth: '2',
                    data: this.proteinData,
                    yAxisID: 'y-axis-2'
                }
            ]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                callbacks: {
                    title: (titleItem, data) => {
                        return formatDate(new Date(titleItem[0].xLabel), true, true)
                    },
                    label: (tooltipItem, data) => {
                        let labelName = data.datasets[tooltipItem.datasetIndex].label || '', labelUnit = ' g'
                        if(labelName == 'Calories')
                            labelUnit = ' cal'
                        return labelName + ': ' + tooltipItem.yLabel + labelUnit 
                    }
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    time: {
                        unit: 'day',
                        displayFormats: {
                            'day': 'MMM D'
                        }
                    },
                    ticks: {
                        max: new Date(),
                        min: new Date().setDate(new Date().getDate() - 30),
                        source: 'labels'
                    }
                }],
                yAxes: [{
                    id: 'y-axis-1',
                    position: 'left',
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Calories (in cal)'
                    }
                }, {
                    id: 'y-axis-2',
                    position: 'right',
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'Macro Nutrients (in g)'
                    },
                    gridLines: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        }
                }]
            }
        })
    },

    methods: {
        getDataPoint(nutrientObj, nutrientKey) {
            return {
                x: nutrientObj.time,
                y: Math.round(nutrientObj[nutrientKey])
            }
        },
        /**
         * Gets an array of the time labels to put in the X axis
         * 
         * @returns {[Date]}
         */
        getTimeLabelArray() {
            let currentDate = new Date()
            currentDate.setHours(0)
            let lastDate = new Date()
            lastDate.setDate(currentDate.getDate() - 30)
            lastDate.setHours(0)
            let dateArray = []
            for (let i = 0; lastDate <= currentDate; lastDate.setDate(lastDate.getDate() + 1), i++) {
                if(i % 2 === 0)
                    dateArray.push(lastDate.getTime())
            }
            return dateArray
        }
    },

    computed: {
        energyData() {
            return this.data.filter((nutrientObj) => nutrientObj.energy).map((nutrientObj) => this.getDataPoint(nutrientObj, 'energy'))
        },
        carbohydratesData() {
            return this.data.filter((nutrientObj) => nutrientObj.carbohydrates).map((nutrientObj) => this.getDataPoint(nutrientObj, 'carbohydrates'))
        },
        fatData() {
            return this.data.filter((nutrientObj) => nutrientObj.fat).map((nutrientObj) => this.getDataPoint(nutrientObj, 'fat'))
        },
        proteinData() {
            return this.data.filter((nutrientObj) => nutrientObj.protein).map((nutrientObj) => this.getDataPoint(nutrientObj, 'protein'))
        }
    }
}
</script>

<style scoped>
canvas {
    max-height: 400px !important;
}
</style>